import { makeStyles } from "tss-react/mui";

// Common styles for all charts
export const useChartStyles = makeStyles()((theme) => ({
  // Common container styles
  chartContainer: {
    height: "65vh",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  
  // Tooltip styles (from all three charts)
  customTooltip: {
    background: "#e9e9e9",
    padding: "6px 12px",
    border: "1px solid",
    borderRadius: "3px",
    boxShadow: "0px 2px 5px rgba(0,0,0,0.15)",
  },
  tooltipLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    "& p": {
      margin: "0px !important",
    },
  },
  colorBox: {
    width: "12px",
    height: "12px",
    // Border radius and background will be set dynamically based on chart type
  },
  tooltipHeader: {
    margin: 0,
    fontWeight: 'bold',
    borderBottom: '1px solid #ccc',
    paddingBottom: '4px',
    marginBottom: '4px',
  },
  
  // Interactive element styles
  clickableElement: {
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  },
  
  // PieChart specific
  pieStyles: {
    height: '65vh',
  },
  clickableSlice: {
    cursor: 'pointer',
  },
  
  // TreeMap specific
  treeMapStyles: {
    height: '65vh',
    width: '100%',
  },
  clickableRect: {
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  },
  
  // Axis tick styles for custom date axis
  xAxisMonthLabel: {
    fontWeight: 'bold',
    fontSize: 14,
    fill: '#333',
    textAnchor: 'end',
    dominantBaseline: 'hanging',
    fontFamily: 'Arial, sans-serif',
  },
  xAxisDayTick: {
    fontWeight: 400,
    fontSize: 10,
    fill: '#888',
    textAnchor: 'middle',
    dominantBaseline: 'hanging',
    fontFamily: 'Arial, sans-serif',
  },
  xAxisTickLine: {
    stroke: '#ccc',
    strokeWidth: 1,
  },
})); 